<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">
        {{ location }}
      </h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.movement-entry.order_gtin_detail.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.movement-entry.order_gtin_detail.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box
          dark
          color="outline"
          :title="$t('lang.movement-entry.order_gtin_detail.box_title_1')"
          class="col-12 col-md-auto p-1"
        >
          <div class="detail-titles">
            <h4>
              <strong>{{ gtinData.gtin }}</strong>
            </h4>
          </div>
        </bx-box>

        <bx-box
          dark
          color="outline"
          :title="$t('lang.movement-entry.order_gtin_detail.box_title_2')"
          class="col-12 col-md-auto p-1"
        >
          <template slot="actions">
            <bx-order-status
              :status="order.destination_status"
              dark
            ></bx-order-status>
          </template>
          <div class="detail-titles">
            <h5>
              Nº <strong>{{ order_id }}</strong>
            </h5>
          </div>
        </bx-box>
      </div>
      <skeleton-boxes :boxes="2" v-else />
    </div>

    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row" style="margin: 8px">
          <bx-btn @click="$router.back()">{{
            $t("lang.messages.go_back")
          }}</bx-btn>
        </div>
        <div class="row">
          <div class="col-12">
            <bx-box
              title=""
              color="white"
              no-padding
              class=""
              v-if="!shouldLoading"
            >
              <bx-gtin :gtin="gtinData"></bx-gtin>
            </bx-box>

            <div
              class="row p-4 m-1"
              v-if="shouldLoading"
              style="background: white"
            >
              <div class="col-12 col-md-6">
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
                <PuSkeleton height="15px" class="title"></PuSkeleton>
                <PuSkeleton height="15px"></PuSkeleton>
                <hr />
              </div>
              <div class="col-12 col-md-6">
                <PuSkeleton class="skeleton-gtin-image"></PuSkeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "movements-order-entry-article-detail",
  props: {
    order_id: {
      type: [Number, String]
    },
    gtin: {
      type: [Number, String]
    }
  },
  data() {
    return {
      shouldLoading: true,
      order: {},
      data: [],
      boxes: [],
      gtinData: {},
      reloadInterval: null
    };
  },
  computed: {
    location() {
      return localStorage.getItem("location");
    }
  },
  methods: {
    async getData() {
      // Order data
      this.order = await this.$api.morders.get(this.order_id);

      // Gtin data
      const data = await this.$api.types.get(this.gtin);
      this.gtinData = {
        image: require("@/assets/i/demoArticle.jpg"),
        category: "Camisetas",
        code: data.description,
        size: data.size,
        color: data.colour,
        gtin: data.gtin,
        model: data.model,
        season: data.season,
        section: data.section
      };

      this.shouldLoading = false;
    }
  },
  mounted() {
    this.reloadInterval = setInterval(
      this.getData,
      process.env.VUE_APP_RELOAD_TIME
    );
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>

<style scoped>
.detail-titles {
  min-height: 45px !important;
}

.skeleton-gtin-image {
  height: 270px;
}

@media screen and (min-width: 1025px) {
  .skeleton-gtin-image {
    height: 500px;
  }
}

@media screen and (max-width: 1024px) {
  .skeleton-gtin-image {
    height: 270px;
  }
}

@media screen and (max-width: 767px) {
  .skeleton-gtin-image {
    height: 240px;
  }
}

.title >>> span {
  width: 150px;
}
</style>
